// ========================================
// INVOICE CONFIGURATION
// ========================================
// Edit these values to configure invoice creation

// Environment-specific configurations
export const ENV_CONFIG = {
  dev: {
    accountTaxIds: ["txi_MOCK_DEV_TAX_ID_12345"],
    renderingTemplateId: "inrtem_MOCK_DEV_TEMPLATE_12345",
    products: {
      proBono: {
        description: "Mira One – Pro Bono",
        productId: "prod_MOCK_DEV_PROBONO_123",
        priceId: "price_MOCK_DEV_PROBONO_456",
        amount: 0,
        metadata: {
          type: "Mira One – Pro Bono",
        },
      },
      starter: {
        description: "Mira One – Starter",
        productId: "prod_MOCK_DEV_STARTER_123",
        priceId: "price_MOCK_DEV_STARTER_456",
        amount: 400,
        metadata: {
          type: "Mira One – Starter",
        },
      },
      professional: {
        description: "Mira One – Professional",
        productId: "prod_MOCK_DEV_PROFESSIONAL_123",
        priceId: "price_MOCK_DEV_PROFESSIONAL_456",
        amount: 800,
        metadata: {
          type: "Mira One – Professional",
        },
      },
    },
  },
  prod: {
    accountTaxIds: ["txi_MOCK_PROD_TAX_ID_67890"],
    renderingTemplateId: "inrtem_MOCK_PROD_TEMPLATE_67890",
    products: {
      proBono: {
        description: "Mira One – Pro Bono",
        productId: "prod_MOCK_PROD_PROBONO_789",
        priceId: "price_MOCK_PROD_PROBONO_012",
        amount: 0,
        metadata: {
          type: "Mira One – Pro Bono",
        },
      },
      starter: {
        description: "Mira One – Starter",
        productId: "prod_MOCK_PROD_STARTER_789",
        priceId: "price_MOCK_PROD_STARTER_012",
        amount: 400,
        metadata: {
          type: "Mira One – Starter",
        },
      },
      professional: {
        description: "Mira One – Professional",
        productId: "prod_MOCK_PROD_PROFESSIONAL_789",
        priceId: "price_MOCK_PROD_PROFESSIONAL_012",
        amount: 800,
        metadata: {
          type: "Mira One – Professional",
        },
      },
    },
  },
};

// ========================================
// INVOICES CONFIGURATION
// ========================================
// Each invoice contains its own config and line items
// Add new invoices by creating new entries in this object

export const INVOICES = {
  invoice_00_20XX: {
    config: {
      currency: "eur",
      autoAdvance: false,
      periodStart: "01.03.2025", // DD.MM.YYYY
      periodEnd: "01.04.2025", // DD.MM.YYYY
      // description: "Rechnung für Februar 2025", // Optional invoice-level note
    },
    lineItems: [
      // REGULAR LINE ITEMS
      {
        productType: "professional",
        quantity: 30,
        periodStart: "01.03.2025", // DD.MM.YYYY
        periodEnd: "01.04.2025", // DD.MM.YYYY
        // description: "One-time setup fee", // Optional: Override product description
        // total: 500, // Optional: Use custom total amount (in cents) instead of unitAmount
      },

      // PRORATED LINE ITEMS

      // REGULAR LINE ITEMS
      {
        productType: "starter",
        quantity: 6,
        periodStart: "01.03.2025", // DD.MM.YYYY
        periodEnd: "01.04.2025", // DD.MM.YYYY
        // total: 1342, // Optional: Use custom total (in cents)
        // description: ""Custom description", // Optional: Override product description
      },

      // PRORATED LINE ITEMS
      {
        productType: "starter",
        quantity: 5,
        periodStart: "03.02.2025", // DD.MM.YYYY
        periodEnd: "01.03.2025", // DD.MM.YYYY
        description:
          "Ungenutzte Zeit für 5 × Mira One – Starter nach 02 Feb 2025", // Optional: Override product description
        total: -1857, // Optional: Use custom total amount (in cents) instead of unitAmount
      },
      {
        productType: "starter",
        quantity: 6,
        periodStart: "03.02.2025", // DD.MM.YYYY
        periodEnd: "01.03.2025", // DD.MM.YYYY
        description:
          "Verbleibende Zeit für 6 x Mira One – Starter nach 02 Feb 2025", // Optional: Override product description
        total: 2229, // Optional: Use custom total amount (in cents) instead of unitAmount
      },

      // REGULAR LINE ITEMS
      {
        productType: "proBono",
        quantity: 3,
        periodStart: "01.03.2025", // DD.MM.YYYY
        periodEnd: "01.04.2025", // DD.MM.YYYY
        // description: "Custom description", // Optional: Override product description
      },
    ],
  },
};

// Environment toggle: true = development, false = production
export const USE_DEV_ENVIRONMENT = false;

// Select which invoice to create (change this to create different invoices)
export const ACTIVE_INVOICE = "invoice_00_20XX";

// Legacy exports for backward compatibility (will use ACTIVE_INVOICE)
export const INVOICE_CONFIG = INVOICES[ACTIVE_INVOICE].config;
export const LINE_ITEMS_CONFIG = INVOICES[ACTIVE_INVOICE].lineItems;
